import type {AxiosRequestConfig} from 'axios';
import {} from './interface';

export class GetReportsCurrentOrdersRequestBuilder {
  private readonly usersRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/reports/current-orders',
    params: {},
  };

  build() {
    return this.usersRequest;
  }
}

// export class GetReportsCenterOrdersRequestBuilder {
//   private readonly reportsRequest: AxiosRequestConfig = {
//     method: 'POST',
//     url: '/reports/center-orders',
//     params: {},
//   };
//   id(id: number) {
//     this.reportsRequest.url = `/reports/center-orders/${id}`;
//     return this;
//   }

//   build() {
//     return this.reportsRequest;
//   }
// }

export class GetReportsCenterOrdersRequestBuilder {
  private readonly reportsRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/reports/center-orders',
    params: {},
  };

  id(id: number) {
    this.reportsRequest.url = `/reports/center-orders/${id}`;
    return this;
  }

  params(params: object) {
    this.reportsRequest.params = params;
    return this;
  }

  build() {
    return this.reportsRequest;
  }
}
